import React from "react";
import { Argument } from "classnames/dedupe";

export type TSearchClasses = {
  searchBar?: Argument;
  dropdownListRoot?: Argument;
  dropdownListContent?: Argument;
  results?: Argument;
};
export interface ISearchContext {
  /**
   * Toggle the search results view and active styles
   */
  isActive: boolean;
  /**
   * Input from user
   */
  searchTerm: string;
  /** Item is clicked */
  selectedItem: string;
  /** Handler for input field */
  handleInputChange(value: string): void;
  /** Register click on result items */
  handleListItemClick(id: string): void;
  /** Clears input value */
  clearSearch(): void;
  /** Closes modal/dropdown */
  closeSearch(): void;
  /** Opens modal/dropdown */
  setActiveSearch(): void;
}

export const SearchContext = React.createContext<ISearchContext>({
  isActive: false,
  searchTerm: "",
  selectedItem: "",
  handleInputChange: () => {},
  handleListItemClick: () => {},
  clearSearch: () => {},
  closeSearch: () => {},
  setActiveSearch: () => {},
});
